import Vue from 'vue'
import Vuex from 'vuex'
import {
    fnApiFetchWeeklyApproval,
}from '../../api/api-applications-salesforce.js'

Vue.use(Vuex)

const actions = {
    WeeklyApproval(context, formWeeklyApproval){
        // console.log(formWeeklyApproval)
        return new Promise((resolve, reject) => {
            fnApiFetchWeeklyApproval(formWeeklyApproval)
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },
}

export default new Vuex.Store({
    namespaced: true,
    actions
})